import { useEffect, useRef, useState } from 'react';

const label = 'Get the finished album by email';

export function AlbumEmailLabel() {
  const target = useRef<HTMLSpanElement>(null);
  const [played, setPlayed] = useState(false);
  useEffect(() => {
    if (played || !target.current || !('IntersectionObserver' in window)) return;
    const motion = window.matchMedia('(max-width: 600px) and (prefers-reduced-motion: no-preference)');
    let observer: IntersectionObserver | undefined;
    function watch() {
      observer?.disconnect();
      if (!motion.matches || !target.current) return;
      const inset = Math.round(window.innerHeight * 0.35);
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setPlayed(true);
          observer?.disconnect();
        }
      }, { rootMargin: `-${inset}px 0px -${inset}px 0px`, threshold: 0.5 });
      observer.observe(target.current);
    }
    watch();
    window.addEventListener('resize', watch);
    motion.addEventListener('change', watch);
    return () => { observer?.disconnect(); window.removeEventListener('resize', watch); motion.removeEventListener('change', watch); };
  }, [played]);
  let index = 0;
  return <span ref={target} className={`album-email-label${played ? ' has-waved' : ''}`} aria-hidden="true">
    {label.split(' ').map((word, wordIndex) => <span className="album-email-word" key={wordIndex}>
      {wordIndex > 0 && ' '}{[...word].map((letter) => {
        const position = index++;
        return <span className="album-email-letter" key={position} style={{ animationDelay: `${position * 24}ms` }}>{letter}</span>;
      })}
    </span>)}
  </span>;
}
